import React from 'react'
import { DefaultLayout } from 'layouts/default'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { Dashboard } from '../pages/Dashboard'
import { SignIn } from '../pages/Auth/SignIn'
import { SignUp } from '../pages/Auth/SignUp'
import { Verification } from '../pages/Auth/Verification'
import { Workouts } from 'pages/Workouts'
import { useAuth } from 'hooks/useAuth'
import { BasicLayout } from '../layouts/BasicLayout'
import { RoutineList } from '../pages/TrainingBench/RoutineList'
import { TrainingList } from '../pages/TrainingBench/TrainingList'
import { TrainingWorkoutList } from '../pages/TrainingBench/TrainingWorkoutList'
import { Athletes } from '../pages/Atlhetes'
import { AuthLayout } from '../layouts/AuthLayout'
import { ForgotPassword } from '../pages/Auth/ForgotPassword'
import { AthleteRoutineList } from '../pages/Atlhetes/AthleteRoutineList'
import { AthleteTrainingList } from '../pages/Atlhetes/AthleteTrainingList'
import { AthleteTrainingWorkout } from '../pages/Atlhetes/AthleteTrainingWorkout'
import { BasicLayoutWithHeader } from '../layouts/BasicLayoutWithHeader'
import { Profile } from '../pages/Profile'

type Props = {
  isAllowed: boolean
  redirectPath?: string
  children?: JSX.Element
}

const ProtectedRoute = ({ isAllowed, redirectPath = '/signIn', children }: Props) => {
  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />
  }
  return children ?? <Outlet />
}

export default function Router () {
  const { user } = useAuth()

  return (
    <Routes>
      <Route path="*" element={<p>There is nothing here: 404!</p>} />
      <Route path="renew" element={<Navigate to="/dashboard" replace />} />
      <Route path="subscription" element={<Navigate to="/dashboard" replace />} />
      <Route path="/" element={<DefaultLayout />}>
        <Route element={<ProtectedRoute isAllowed={!!user} />}>
          <Route path="/" element={<BasicLayout />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
          </Route>
          <Route path="/profile" element={<BasicLayout />}>
            <Route index element={<Profile />} />
          </Route>
          <Route path="routine" element={<BasicLayout />}>
            <Route index element={<RoutineList />} />
            <Route path=":routineId">
              <Route index element={<TrainingList />} />
              <Route path=":id" element={<TrainingWorkoutList />} />
            </Route>
          </Route>
          <Route path="athletes" element={<BasicLayout />}>
            <Route index element={<Athletes />} />
            <Route path=":professionalAthleteId/routines" element={<BasicLayoutWithHeader />}>
              <Route index element={<AthleteRoutineList />} />
              <Route path=":athleteRoutineId/trainings">
                <Route index element={<AthleteTrainingList />} />
                <Route path=":id/training-workouts" element={<AthleteTrainingWorkout />} />
              </Route>
            </Route>
          </Route>
          <Route path="workouts" element={<BasicLayout />}>
            <Route index element={<Workouts />} />
          </Route>
        </Route>
      </Route>
      <Route element={<AuthLayout />}>
        <Route path="/signIn" element={<SignIn />} />
        <Route path="/signUp" element={<SignUp />} />
        <Route path="/verification" element={<Verification />} />
        <Route path="/forgot" element={<ForgotPassword />} />
      </Route>
    </Routes>
  )
}
